/* Technologies Data */
const TechsData = [
    {
        id:0,
        desc:'React JS',
        img:'https://img.icons8.com/color/144/null/react-native.png'
    },
    {
        id:1,
        desc:'Node JS',
        img:'https://img.icons8.com/fluency/144/null/node-js.png'
    },
    {
        id:2,
        desc:'Express JS',
        img:'https://img.icons8.com/color/144/null/express-js.png'
    },
    {
        id:3,
        desc:'MongoDB',
        img:'https://img.icons8.com/color/144/null/mongodb.png'
    },
    {
        id:4,
        desc:'Git',
        img:'https://img.icons8.com/color/144/null/git.png'
    },
    {
        id:5,
        desc:'HTML',
        img:'https://img.icons8.com/color/144/null/html-5--v1.png'
    },
    {
        id:6,
        desc:'Material UI',
        img:'https://img.icons8.com/color/144/null/material-ui.png'
    },
    {
        id:7,
        desc:'CSS',
        img:'https://img.icons8.com/color/144/null/css3.png'
    },
    {
        id:8,
        desc:'JavaScript',
        img:'https://img.icons8.com/color/144/null/javascript--v1.png'
    }
];

export default TechsData;